import React from 'react';
import { useChatContext } from './store/ChatContext';

const ToolStatusBar: React.FC = () => {
  const { state } = useChatContext();
  if (!state.activeToolLabel) return null;
  return (
    <div className="bot-tool-status">
      <span className="bot-tool-status__spinner" />
      <span className="bot-tool-status__label">{state.activeToolLabel}</span>
    </div>
  );
};

export default ToolStatusBar;
